var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSb(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 54,
    height: 40,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.3 0h53.4v40H.3z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0000d6",
    d: "M.3 39.6 77.5 0H.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006000",
    d: "M80.3 0 2.5 40h77.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M80.3 0H76L.3 38v2h4.3L80.3 2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m6 .7.8 2.7h3L7.4 5.1l1 2.6-2.5-1.6-2.4 1.7 1-2.7L2 3.4h3zm14.8 0 1 2.7h3l-2.5 1.7 1 2.7L20.8 6l-2.4 1.7 1-2.7-2.5-1.7h3zm0 11.3 1 2.7h3l-2.5 1.7 1 2.6-2.5-1.6-2.4 1.6 1-2.6-2.5-1.7h3zm-7.4-5.6 1 2.7h3l-2.5 1.7 1 2.7-2.5-1.7-2.4 1.7 1-2.7L9.4 9h3zM6 12l1 2.7h3l-2.5 1.7 1 2.6L6 17.4 3.5 19l1-2.6L2 14.7h3z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.3 0h53.3v40H.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSb);
export default __webpack_public_path__ + "static/media/sb.e0d8261e30c8d2d36b8fbdd173dfa50d.svg";
export { ForwardRef as ReactComponent };